$(document).ready(() => {
	initMermaidPanzoom()
	set_tables()
	document.addEventListener('click', function (event) {
		const clickedLink = event.target.closest('a.sidebar-group-item-title');
		if (!clickedLink) return;
		initMermaidPanzoom();
		set_tables()
	})
});


const set_tables = () => {
	setTimeout(() => {
		const tables = document.querySelectorAll('table');
		if(!tables.length) return;
		tables.forEach(table => {
			const headers = table.querySelectorAll('thead th');
			headers.forEach((th, colIndex) => {
				if (th.textContent.trim() == '日期') {
					th.style.minWidth = '120px';

					const rows = table.querySelectorAll('tbody tr');
					rows.forEach(row => {
						const cell = row.querySelector(`td:nth-child(${colIndex + 1})`);
						if (cell) cell.style.width = '120px';
					});
				} else if (th.textContent.trim() == '序号') {
					th.style.maxWidth = '80px';

					const rows = table.querySelectorAll('tbody tr');
					rows.forEach(row => {
						const cell = row.querySelector(`td:nth-child(${colIndex + 1})`);
						if (cell) cell.style.width = '80px';
					});
				} else {
					th.style.whiteSpace = 'nowrap';

					const canvas = document.createElement('canvas');
					const ctx = canvas.getContext('2d');

					const computedStyle = window.getComputedStyle(th);
					ctx.font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;

					const textWidth = ctx.measureText(th.textContent).width + 20;

					th.style.minWidth = `${textWidth}px`;

					th.style.overflow = 'hidden';
					th.style.textOverflow = 'ellipsis';
				}
			});
		});

		const table = document.querySelector('table');
		table.style.tableLayout = 'fixed';
	}, 100)

}

function createButton(text, title) {
	const btn = document.createElement('button');
	btn.textContent = text;
	btn.title = title;
	btn.style.background = 'rgba(255,255,255,0.7)';
	btn.style.border = '1px solid #ccc';
	btn.style.borderRadius = '4px';
	btn.style.padding = '5px 10px';
	btn.style.cursor = 'pointer';
	return btn;
}

function initMermaidPanzoom() {
	setTimeout(() => {
		if (window.mermaid) {
			mermaid.init({
				startOnLoad: false,
				theme: 'base'
			}, '.mermaid');
		}

		const containers = Array.from(document.getElementsByClassName('mermaid'));
		containers.forEach(container => {
			setTimeout(() => {
				const svg = container.querySelector('svg');
				if (!svg) return;

				const controlsDiv = document.createElement('div');
				controlsDiv.style.position = 'absolute';
				controlsDiv.style.top = '10px';
				controlsDiv.style.right = '10px';
				controlsDiv.style.zIndex = '1000';
				controlsDiv.style.display = 'flex';
				controlsDiv.style.gap = '5px';
				container.style.position = 'relative';
				container.appendChild(controlsDiv);

				const zoomInBtn = createButton('+', '放大');
				const zoomOutBtn = createButton('-', '缩小');
				const resetBtn = createButton('↺', '重置');
				controlsDiv.append(zoomInBtn, zoomOutBtn, resetBtn);

				const panzoom = Panzoom(svg, {
					maxZoom: 5,
					minZoom: 0.5,
					initialZoom: 1,
					bounds: true,
					boundsPadding: 0.1
				});

				svg.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);

				zoomInBtn.addEventListener('click', () => panzoom.zoomIn());
				zoomOutBtn.addEventListener('click', () => panzoom.zoomOut());
				resetBtn.addEventListener('click', () => panzoom.reset());


				document.addEventListener('keydown', (e) => {
					if (e.ctrlKey && e.key === '0') panzoom.reset();
				});
			}, 500);
		});
		// set_tables()
	}, 300);
}